import { IS_TESTNET, SUPPORTED_NETWORK } from '@/utils'

export const BTC_SYMBOL = 'BTC'
export const NATIVE_TOKEN_ADDRESS = 'native'
export const WRAPPED_ETH_TOKEN_SYMBOL = 'WETH'
export const EVM_ICON_URL = '/wallet/evm.svg'
export const USDT_SYMBOL = 'USDT'

export const BTC_NETWORK_ID = IS_TESTNET ? SUPPORTED_NETWORK.BTC_TESTNET : SUPPORTED_NETWORK.BTC
